import React, { useEffect } from 'react';

import { Form, useFormikContext } from 'formik';

import { AdditionalAddressTypes } from '@pages/BookingProcess/Constants';

import AdditionalAddress from './AdditionalAddress';
import CreateDialogForm from '../Participants/ParticipantDialogForm/CreateDialogForm';

const CreateForm = ({
  values,
  setIsFormValid,
  disableKeyFields = false,
  configuration = {},
  isEventFree = false,
  isEventIlias = false
}) => {
  const { submitForm, isValid } = useFormikContext();

  useEffect(() => {
    setIsFormValid(isValid);
  }, [isValid]);

  useEffect(() => {
    return () => {
      submitForm();
    };
  }, []);

  return (
    <>
      <Form>
        <CreateDialogForm
          setIsFormValid={setIsFormValid}
          disableKeyFields={disableKeyFields}
          configuration={configuration}
          isEventFree={isEventFree}
          isEventIlias={isEventIlias}
        />
        {!isEventFree && (
          <AdditionalAddress addressConfig={AdditionalAddressTypes.Billing} values={values} />
        )}
        <AdditionalAddress
          addressConfig={AdditionalAddressTypes.Communication}
          values={values}
          isEventFree={isEventFree}
        />
      </Form>
    </>
  );
};
export default CreateForm;
